<template>
  <span class="echarts-pie">
    <div :id="eid" class="main-pie"></div>
  </span>
</template>

<script>
  import * as echarts from 'echarts';
  import GetFormatTime from '@/utils/time-format.js';
  export default {
    props: {
      eid: {
        type: String
      },
      data: {
        type: [Object, Array]
      },
      menuType: {
        type: String
      }
    },
    data() {
      return {
        myChart: '',
        barWidth: 10,
        newchartName: [],
        newchartValue1: [],
        newchartValue2: [],
        path: 'path://M1390,595h79l-39,22Z',
        color1: {
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          type: 'linear',
          global: false,
          colorStops: [{
              //第一节下面
              offset: 0,
              color: '#1C98CD'
            },
            {
              offset: 1,

              color: 'rgba(61,187,255,.16)'
            }
          ]
        },
        color2: {
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          type: 'linear',
          global: false,
          colorStops: [{
              //第一节下面
              offset: 0,
              color: '#E7AB47'
            },
            {
              offset: 1,
              color: 'rgba(255,164,41,.16)'
            }
          ]
        },
        yAxisName: this.menuType
      };
    },
    methods: {
      reset() {
        this.$nextTick(function() {
          if (
            //判断是否存在echarts实例化对象,如果存在则销毁
            this.myChart != null && this.myChart != '' && this.myChart != undefined
          ) {
            this.myChart.dispose()
          }
          let dom = document.getElementById(this.eid);
          this.myChart = echarts.init(dom);
          let tmp = this.init();
          if (tmp) {
            this.myChart.setOption(tmp);
          } else {
            console.log('数据问题chargingStatistics');
          }
        });
      },
      init() {
        let newchartValueEnd1 = [];
        let newchartValueEnd2 = [];
        let newchartValueDo1 = [];
        let newchartValueDo2 = [];
        let xAxis = [];
        if (this.data.chargingStatistics) {             // 日充放电量
          xAxis = this.data.chargingStatistics.timestamps;
          this.newchartValue1 = this.data.chargingStatistics.data;
          this.newchartValue2 = this.data.dischargingStatistics.data;
          this.newchartValue1.forEach((item, index) => {
            newchartValueEnd1.push({
              name: '',
              value: item,
              symbolPosition: 'end'
            });
            newchartValueDo1.push({
              name: '',
              value: item
            });
          });
          this.newchartValue2.forEach(item => {
            newchartValueEnd2.push({
              name: '',
              value: item,
              symbolPosition: 'end'
            });
            newchartValueDo2.push({
              name: '',
              value: item
            });
          });
          //获取数据最大值
          let list = this.newchartValue1.concat(this.newchartValue2).sort(function(a, b) {
            return b - a;
          });
          var max = list[0];
          if (parseInt(max) < 100) {
            max = 100;
          } else {
            max = max + 20;
          }
        } else if (this.data.incomeChart) {                 // 收益统计
          xAxis = this.data.incomeChart.timestamps;
          this.newchartValue1 = this.data.incomeChart.data;
          this.newchartValue1.forEach((item, index) => {
            newchartValueEnd1.push({
              name: '',
              value: item,
              symbolPosition: 'end'
            });
            newchartValueDo1.push({
              name: '',
              value: item
            });
          });
          //获取数据最大值
          let list = this.newchartValue1.slice().sort(function(a, b) {
            return b - a;
          });
          var max = list[0];
          if (parseInt(max) < 100) {
            max = 100;
          } else {
            max = max + 20;
          }
        } else {
          let timeList = [];
          let time = new Date().getTime();
          for (let i = 1; i < 8; i++) {
            timeList.push(time - i * 24 * 3600 * 1000);
          }
          timeList.sort(function(a, b) {
            return a - b;
          });
          for (let j = 0; j < timeList.length; j++) {
            xAxis.push(GetFormatTime({
              time: timeList[j],
              format: "yyyy-MM-dd"
            }))
          }
          this.newchartValue1 = [0, 0, 0, 0, 0, 0, 0];
          this.newchartValue2 = [0, 0, 0, 0, 0, 0, 0];
        }
        let op = {
          legend: {
            top: 0,
            right: 0,
            icon: 'rect',
            itemWidth: 17, // 图例标记的图形宽度。[ default: 25 ]
            itemHeight: 12, // 图例标记的图形高度。[ default: 14 ]
            itemGap: 9, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
            textStyle: {
              fontSize: 12,
              color: '#08265F'
            },
            data: this.data.incomeChart ? [] : ['充电量', '放电量'],
            selectedMode: false
          },
          //提示框
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'none'
            },
            formatter: function(param) {
              var resultTooltip =
                "<div style='background:rgba(13,5,30,.3);border:1px solid rgba(255,255,255,.2);padding:5px 10px;border-radius:4px;'>" +
                "<div style='text-align:center;'>" +
                param[0].name +
                '</div>' +
                "<div style='padding-top:5px;'>" +
                "<span style='display:inline-block;border-radius:4px;width:20px;height:10px;background-color:rgba(61,187,255,.3);border: 2px solid #3eb6f5;'></span>" +
                "<span style=''> " +
                param[0].seriesName +
                ': </span>' +
                "<span style=''>" +
                param[0].value +
                '</span>' +
                '</div>' +
                "<div style='padding-top:5px;'>" +
                "<span style='display:inline-block;border-radius:4px;width:20px;height:10px;background-color:rgba(255,164,41,.3);border: 2px solid #ffc241;'></span>" +
                "<span style=''> " +
                param[1].seriesName +
                ': </span>' +
                "<span style=''>" +
                param[1].value +
                '</span>' +
                '</div>';
              if (param[0].seriesName === '收益') {
                resultTooltip =
                  "<div style='background:rgba(13,5,30,.3);border:1px solid rgba(255,255,255,.2);padding:5px 10px;border-radius:4px;'>" +
                  "<div style='text-align:center;'>" +
                  param[0].name +
                  '</div>' +
                  "<div style='padding-top:5px;'>" +
                  "<span style='display:inline-block;border-radius:4px;width:20px;height:10px;background-color:rgba(61,187,255,.3);border: 2px solid #3eb6f5;'></span>" +
                  "<span style=''> " +
                  param[0].seriesName +
                  ': </span>' +
                  "<span style=''>" +
                  param[0].value +
                  '</span>';
              }
              return resultTooltip;
            }
          },
          title: '',
          grid: {
            top: '25%',
            left: '7%',
            bottom: '0%',
            right: '5%',
            containLabel: true
          },
          animation: false,
          xAxis: [{
              type: 'category',
              axisTick: {
                show: false
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: '#08265F'
                }
              },
              axisLabel: {
                inside: false,
                  color: '#08265F',
                  fontWeight: 'normal',
                  fontSize: 10,
                formatter: function(params) {
                  let res = '';
                  let strs = [];
                  let y = '',
                    m = '',
                    d = '';
                  strs = params.split('-');
                  y = strs[0];
                  m = strs[1];
                  d = strs[2];
                  return m + '-' + d + '\n' + y;
                },
                margin: 20 //刻度标签与轴线之间的距离。
              },
              data: xAxis
            },
            {
              type: 'category',
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: false
              },
              splitArea: {
                show: false
              },
              splitLine: {
                show: false
              },
              data: xAxis
            }
          ],
          yAxis: [{
            name: this.data.incomeChart ? '收益(元)' : this.yAxisName == 'home' ? '电量(MWh)' : '电量(kWh)',
            nameTextStyle: {
              color: '#08265F',
              fontSize: 12,
              padding: [0, 0, 0, -30]
            },
            show: true,
            type: 'value',
            axisLabel: {
                fontSize: 10,
                color: '#08265F'
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(4, 126, 232, 0.1)',
                type: 'dashed'
              }
            },
            axisLine: {
              show: false
            }
          }],
          series: [
            // 柱子本身
            {
              name: '充电量',
              type: 'bar',
              barGap: '60%',
              barWidth: this.barWidth,
              itemStyle: {
                color: this.color1,
                borderColor: this.color1,
                borderWidth: 1,
                borderType: 'solid'
              },
              label: {
                show: false,
                formatter: '{c}' + '%',
                position: 'left',
                color: 'rgba(119,167,255,1)',
                fontSize: 12,
                textAlign: 'center'
              },
              zlevel: 2,
              data: this.newchartValue1
            },
            {
              name: '放电量',
              type: 'bar',
              barGap: '60%',
              barWidth: this.barWidth,
              show: false,
              itemStyle: {
                // color: 'rgba(255,164,41,.16)',
                color: this.color2,
                borderColor: this.color2,
                borderWidth: 1,
                borderType: 'solid'
              },
              label: {
                show: false,
                formatter: '{c}' + '%',
                position: 'right',
                color: 'rgba(255,228,59,1)',
                fontSize: 12,
                textAlign: 'center'
              },
              zlevel: 2,
              data: this.newchartValue2
            },

            // y=Ymax 的实心圆圈
            {
              name: '已开工未完成',
              type: 'effectScatter',
              rippleEffect: {
                period: 1,
                scale: 4,
                brushType: 'fill'
              },
              show: true,
              z: 20,
              zlevel: 2,
              symbolPosition: 'end',
              // symbol: path,
              symbolSize: [6, 4],
              symbolOffset: [-8, -2],
              itemStyle: {
                // shadowColor: 'rgba(0, 0, 0, .3)',
                shadowBlur: 5,
                shadowOffsetY: 3,
                shadowOffsetX: 0,
                color: 'rgba(119,167,255,1)'
              },
              data: [{
                  name: '',
                  value: max,
                  symbolPosition: 'end'
                },
                {
                  name: '',
                  value: max,
                  symbolPosition: 'end'
                },
                {
                  name: '',
                  value: max,
                  symbolPosition: 'end'
                },
                {
                  name: '',
                  value: max,
                  symbolPosition: 'end'
                },
                {
                  name: '',
                  value: max,
                  symbolPosition: 'end'
                },
                {
                  name: '',
                  value: max,
                  symbolPosition: 'end'
                },
                {
                  name: '',
                  value: max,
                  symbolPosition: 'end'
                }
              ]
            },
            {
              name: '已开工未完成',
              type: 'effectScatter',
              rippleEffect: {
                period: 1,
                scale: 4,
                brushType: 'fill'
              },
              show: false,
              z: 20,
              zlevel: 2,
              symbolPosition: 'end',
              // symbol: path,
              symbolSize: [6, 4],
              symbolOffset: [8, -2],
              itemStyle: {
                // shadowColor: 'rgba(0, 0, 0, .3)',
                shadowBlur: 5,
                shadowOffsetY: 3,
                shadowOffsetX: 0,
                color: 'rgba(255,164,41,0.5)'
              },
              data: [{
                  name: '',
                  value: max,
                  symbolPosition: 'end'
                },
                {
                  name: '',
                  value: max,
                  symbolPosition: 'end'
                },
                {
                  name: '',
                  value: max,
                  symbolPosition: 'end'
                },
                {
                  name: '',
                  value: max,
                  symbolPosition: 'end'
                },
                {
                  name: '',
                  value: max,
                  symbolPosition: 'end'
                },
                {
                  name: '',
                  value: max,
                  symbolPosition: 'end'
                },
                {
                  name: '',
                  value: max,
                  symbolPosition: 'end'
                }
              ]
            },

            // 柱子末端的实心圆圈
            {
              name: '充电量',
              type: 'pictorialBar',
              symbolSize: [this.barWidth, 10],
              symbolOffset: ['-81%', -5],
              symbolPosition: 'end',
              z: 15,
              color: 'rgba(29,139,193,0.9)',
              zlevel: 4,
              data: this.newchartValue1
            },
            {
              name: '放电量',
              type: 'pictorialBar',
              symbolSize: [this.barWidth, 10],
              symbolOffset: ['81%', -5],
              symbolPosition: 'end',
              z: 15,
              color: 'rgba(205,151,67,0.9)',
              zlevel: 2,
              data: this.newchartValue2
            },

            // 背景
            {
              name: '工程量',
              type: 'bar',
              xAxisIndex: 1,
              barGap: '60%',
              data: [max, max, max, max, max, max, max],
              zlevel: 1,
              barWidth: this.barWidth,
              itemStyle: {
                color: 'rgba(61,187,255,.16)'
              }
            },
            {
              name: '合格量',
              type: 'bar',
              xAxisIndex: 1,
              barGap: '60%',
              data: [max, max, max, max, max, max, max],
              zlevel: 1,
              barWidth: this.barWidth,
              itemStyle: {
                color: 'rgba(255,164,41,.16)'
              }
            },

            // 坐标轴上的实心圆圈
            {
              name: '已开工已完成',
              type: 'pictorialBar',
              symbolSize: [this.barWidth, 10],
              symbolOffset: ['-81%', 5],
              z: 12,
              color: '#3eb6f5',
              data: newchartValueDo1
            },
            {
              name: '已完成已合格',
              type: 'pictorialBar',
              symbolSize: [this.barWidth, 10],
              symbolOffset: ['81%', 5],
              z: 12,
              color: '#ffc241',

              data: newchartValueDo2
            },

            // 坐标轴上的实心圆圈
            {
              name: '已开工已完成',
              type: 'pictorialBar',
              symbolSize: [this.barWidth, 10],
              symbolOffset: ['-81%', 5],
              z: 12,
              color: '#3eb6f5',
              data: [{
                  name: '',
                  value: max
                },
                {
                  name: '',
                  value: max
                },
                {
                  name: '',
                  value: max
                },
                {
                  name: '',
                  value: max
                },
                {
                  name: '',
                  value: max
                },
                {
                  name: '',
                  value: max
                }
              ]
            },
            {
              name: '已完成已合格',
              type: 'pictorialBar',
              symbolSize: [this.barWidth, 10],
              symbolOffset: ['81%', 5],
              z: 12,
              color: '#ffc241',
              data: [{
                  name: '',
                  value: max
                },
                {
                  name: '',
                  value: max
                },
                {
                  name: '',
                  value: max
                },
                {
                  name: '',
                  value: max
                },
                {
                  name: '',
                  value: max
                },
                {
                  name: '',
                  value: max
                }
              ]
            },
          ]
        };

        // 万国项目-日充放电量
        if ( this.$route.query.projectId === '86-518045-001' && this.data.chargingStatistics) {
          op.series = [
            // 柱子末端的实心圆圈
            {
              name: '充电量',
              type: 'pictorialBar',
              symbolSize: [this.barWidth, 10],
              symbolOffset: ['-65%', '-50%'],
              symbolPosition: 'end',
              z: 15,
              color: 'rgba(29,139,193,0.9)',
              zlevel: 4,
              data: this.newchartValue1
            },
            {
              name: '放电量',
              type: 'pictorialBar',
              symbolSize: [this.barWidth, 10],
              symbolOffset: ['65%', '-50%'],
              symbolPosition: 'end',
              z: 15,
              color: 'rgba(205,151,67,0.9)',
              zlevel: 2,
              data: this.newchartValue2
            },

            // 柱子本身
            {
              name: '充电量',
              type: 'bar',
              barGap: '30%',
              barWidth: this.barWidth,
              itemStyle: {
                color: this.color1,
                borderColor: this.color1,
                borderWidth: 1,
                borderType: 'solid'
              },
              label: {
                show: false,
                formatter: '{c}' + '%',
                position: 'left',
                color: 'rgba(119,167,255,1)',
                fontSize: 12,
                textAlign: 'center'
              },
              zlevel: 2,
              data: this.newchartValue1
            },
            {
              name: '放电量',
              type: 'bar',
              barGap: '30%',
              barWidth: this.barWidth,
              show: false,
              itemStyle: {
                // color: 'rgba(255,164,41,.16)',
                color: this.color2,
                borderColor: this.color2,
                borderWidth: 1,
                borderType: 'solid'
              },
              label: {
                show: false,
                formatter: '{c}' + '%',
                position: 'right',
                color: 'rgba(255,228,59,1)',
                fontSize: 12,
                textAlign: 'center'
              },
              zlevel: 2,
              data: this.newchartValue2
            },
          ];
        }

        // 万国项目-收益统计
        if ( this.$route.query.projectId === '86-518045-001' && this.data.incomeChart) {
          op.series = [
            // 柱子末端的实心圆圈
            {
              name: '收益',
              type: 'pictorialBar',
              symbolSize: [this.barWidth, 10],
              symbolOffset: ['0%', '-50%'],
              symbolPosition: 'end',
              z: 15,
              color: 'rgba(29,139,193,0.9)',
              zlevel: 4,
              data: this.newchartValue1
            },

            // 柱子本身
            {
              name: '收益',
              type: 'bar',
              barGap: '30%',
              barWidth: this.barWidth,
              itemStyle: {
                color: this.color1,
                borderColor: this.color1,
                borderWidth: 1,
                borderType: 'solid'
              },
              label: {
                show: false,
                formatter: '{c}' + '%',
                position: 'left',
                color: 'rgba(119,167,255,1)',
                fontSize: 12,
                textAlign: 'center'
              },
              zlevel: 2,
              data: this.newchartValue1
            },
          ];
        }
        return op;
      }
    },
    mounted() {}
  };
</script>

<style lang="scss">
  .echarts-pie {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: inline-block;

    .main-pie {
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/echarts-pie.vue